module.exports = __webpack_public_path__ + "img/nuvoair-logo-white.4826979.png";